module.exports = __webpack_public_path__ + "static/media/studio-blocked-popup-mobile.1834733d.png";